import {Button, Icon} from '@dagster-io/ui-components';
import {ComponentProps} from 'react';

import ButtonLogoGitHub from '@/components/logos/ButtonLogoGitHub';
import ButtonLogoGoogle from '@/components/logos/ButtonLogoGoogle';

export enum AuthProvider {
  Google = 'google',
  GitHub = 'github',
  SSO = 'sso',
}

export const AuthProviderNames: Record<AuthProvider, string> = {
  google: 'Google',
  github: 'GitHub',
  sso: 'SSO',
};

export const AuthProviderIcons: Record<AuthProvider, ComponentProps<typeof Button>['icon']> = {
  google: <ButtonLogoGoogle />,
  github: <ButtonLogoGitHub />,
  sso: <Icon name="lock" />,
};
